<style lang="scss" scoped>
@import "/src/styles/css/_variables.css";
@import "./checkbox.scss";
</style>
<template>
  <div class="slk-g-checkbox-wrapper">
    <div
      @click="toggleCheckbox"
      :class="`checkbox-container ${value ? 'is-checked' : ''} ${disabled ? 'disabled' : ''} `"
    >
      <svg class="feather" v-if="value">
        <use :href="`/imgs/storybook/feather-sprite.svg#check`" />
      </svg>
    </div>
    <span class="checkbox-label" v-if="label != ''" v-html="label"></span>
  </div>
</template>

<script>
export default {
  name: "checkbox-view",
  props: {
    value: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    label: { type: String, default: "" },
  },
  methods: {
    toggleCheckbox() {
      if (!this.disabled) {
        // Toggle the 'value' prop and emit an 'input' event to update the parent component
        this.$emit("input", !this.value);
      }
    },
  },
};
</script>
